import { translationUploadData_da } from "./translationUploadData.da";
import { defineDashboardTranslations } from "./translationTypes";
import { translationUploadData_en } from "./translationUploadData.en";
import { translationUploadData_sv } from "./translationUploadData.sv";

export const translationUploadData = defineDashboardTranslations({
  da: translationUploadData_da,
  en: translationUploadData_en,
  sv: translationUploadData_sv,
});
